(function () {
  'use strict';

  var id = 'metric',
    prevDimensions = null;
  angular.module('wsLrs.cards').factory(id + '.Utils', ['CardQueryResource', 'AggregationUtils', '$filter', 'wsEventNames', 'Utils', 'VideoEmbedService', '$q', 'ReportLinks', function (CardQueryResource, AggUtils, $filter, wsEvents, Utils, VideoEmbedService, $q, ReportLinks) {
    var self = {
      fetchData: function fetchData(cfg) {
        cfg = cfg || {};
        return CardQueryResource.getWithProgress("/metric/data", cfg.cardId, cfg.params, cfg.cardToPreview, 'metric-' + cfg.cardId);
      },
      fetchMetricData: function fetchMetricData(fetchCfg, scope) {
        return self.fetchData(fetchCfg).then(function (r) {
          // Advertise that the preview loaded, with the preview data
          if (scope.cardToPreview) {
            scope.$emit(wsEvents.card.preview.loaded, r);
          }
          scope.hasData = Utils._try(function () {
            return r.results[0].result.data.length > 0;
          }, false);
          if (!scope.hasData) {
            return;
          }
          if (scope.pagenote) {
            scope.pagenote.setReportMetadata(r);
          }
          scope.metricData = r.results[0].result.data;
          var aggregations = r.results[0].result.data[0].aggregations;
          self.interpolateMetricText(aggregations, scope);
        }, function () {
          scope.hasData = false;
        });
      },
      /**
       * Replace all the {{}} with the data that's supposed to be there.
       *
       * @param aggregations - The aggregations are the source where most interpolations will be
       *                        evaluated. Not all are evaluated here, however, for instance video
       *                        links will be handled separately.
       * @param scope - The scope variable passed in to re-assign the metricDisplayText
       */
      interpolateMetricText: function interpolateMetricText(aggregations, scope) {
        scope.metricDisplayText = scope.config.textTemplate || '';

        // 1. Replace all metric aggregations
        _.each(aggregations, function (metric, idx) {
          var metricName = 'm' + idx;
          var displayValue = AggUtils.getMeasureValueDisplay(metric, scope.measures[idx]);
          var aggType = scope.measures[idx].aggregation && scope.measures[idx].aggregation.type;
          var isCountAgg = _.contains(['COUNT', 'DISTINCT_COUNT'], aggType);
          var isCollectionAgg = _.contains(['LIST', 'SET'], aggType);
          if (isCountAgg) {
            displayValue = $filter('number')(displayValue);
            scope[metricName] = displayValue;
          } else if (isCollectionAgg) {
            displayValue = "<ws-safe-click ws-ng-click='openModal(metricData[0], measures[" + idx + "], " + idx + ")' text='" + displayValue + "' />";
            scope[metricName] = AggUtils.getMeasureValueDisplay(metric, scope.measures[idx]);
          } else {
            scope[metricName] = displayValue;
          }
          var pattern = "{{(\\s*?)?".concat(metricName, "(\\s*?)?}}"); // Have to double-escape "\"
          // if we have a linked report config, apply it
          if (ReportLinks.hasLinkConfig(scope.config, scope.measures[idx], idx)) {
            scope[metricName] = ReportLinks.applyLinkConfig(scope.config, scope.measures[idx], scope[metricName], idx);

            // for a linked configuration, show the link
            scope.metricDisplayText = scope.metricDisplayText.replace(new RegExp(pattern, 'g'), scope[metricName]);
          } else {
            // otherwise show the displayValue
            scope.metricDisplayText = scope.metricDisplayText.replace(new RegExp(pattern, 'g'), displayValue);
          }
        });

        // 2. Transform passed iframes into video tokens
        scope.metricDisplayText = VideoEmbedService.replaceIframesWithVideoTokens(scope.metricDisplayText);

        // 3. Handle all video embed tokens
        var videoEmbeds = VideoEmbedService.getVideoEmbedsFromString(scope.metricDisplayText);
        scope.metricDisplayText = VideoEmbedService.replaceVideoTokensWithDirectives(scope.metricDisplayText, videoEmbeds);

        // 4. Remove any remaining interpolation brackets because:
        //      1. They are invalid (they weren't aggs or video embeds)
        //      2. They will break the compile directive used to render video embeds.
        scope.metricDisplayText = scope.metricDisplayText.replace(/{{.*?}}/g, '');

        // 5. Remove any potential self-closing iframe tags -- We don't support that
        scope.metricDisplayText = scope.metricDisplayText.replace(/<iframe.*>/g, '');
      }
    };
    return self;
  }]).config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/metric/:cardId', {
      templateUrl: 'modules/app/metric/metric-detail.html',
      controller: id + ".Detail",
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/metric/:cardId/top', {
      templateUrl: 'modules/app/metric/metric-card.html',
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    });
  }]).run(['CardIconMap', function (CardIconMap) {
    CardIconMap.register({
      "metric": "activity"
    });
  }]).controller(id + ".CardConfiguration", ['$controller', '$rootScope', '$scope', 'Measures', 'ExplorerService', function ($controller, $rootScope, $scope, Measures, ExplorerService) {
    // Save off previous dimensions in case the user is going back and forth between report types, we'll
    // re-assign these dimensions when going to a different report type.
    prevDimensions = $scope.workingConfig.dimensions;
    $scope.templateType = id;
    $scope.getMeasures = Measures.getCommonMeasures;
    var cardToEdit = ExplorerService.getCard() || {};
    $scope.metricHelpText = {
      helpTitle: 'Metric',
      detailText: "The Metric report is a way to highlight important data points on a dashboard. \n                            Select the numbers you want to include using the Select a Measure menu. \n                            <a target='_blank' href='https://watershedlrs.zendesk.com/hc/en-us/articles/360026122612'>Learn more</a>\n\n                         Advanced Users can add HTML and embed videos in the Metric Report.\n                         <a href=\"https://watershedlrs.zendesk.com/hc/en-us/articles/360026122612-Metric-Report#using-the-metric-report-as-a-text-box\" target=\"_blank\">Learn More</a>"
    };
    $controller("AggregationCardConfiguration", {
      $scope: $scope
    });

    // Always force the metric dimension to a single "constant" (no dimensions)
    $scope.workingConfig.dimensions = [{
      "type": "CONSTANT"
    }];
    cardToEdit.configuration.dimensions = $scope.workingConfig.dimensions;
    $scope.cardChangeHandlers.push(function () {
      // Set this back to previous dimensions when moving away from metric report
      if ($scope.workingConfig.type === 'metric') {
        $scope.workingConfig.dimensions = prevDimensions;

        // clear metric description and cleanup watcher
        delete $scope.workingConfig.textTemplate;
        cleanupTemplateWatcher();
        $scope.updateCardWithWorkingConfig();
      }
    });
    var cleanupTemplateWatcher = $scope.$watch('workingConfig.textTemplate', function (newValue, oldValue) {
      if ($scope.advancedConfig && newValue !== oldValue) {
        $scope.updateCardWithWorkingConfig();
      }
    });
  }]).controller(id + ".Card", ["$scope", "CardRegistry", id + '.Utils', 'AggregationUtils', '$routeParams', 'ReportValidationService', function ($scope, CardRegistry, Utils, AggUtils, $routeParams, ReportValidationService) {
    if (!$scope.cardId && $routeParams.cardId) {
      $scope.cardId = $routeParams.cardId;
    }
    $scope.card = CardRegistry.get($scope.cardId);
    $scope.config = $scope.card.configuration;
    var validation = ReportValidationService.validate($scope.cardId);
    if (validation.hasErrors) {
      $scope.hasData = false;
      $scope.noDataMsg = validation.message;
      return;
    }

    // If there aren't any measures, this is a simple text display
    $scope.measures = $scope.config.measures;
    if (!$scope.measures || $scope.measures.length < 1) {
      $scope.hasData = true;
      Utils.interpolateMetricText([], $scope);
    } else {
      var fetchCfg = {
        cardId: $scope.cardId,
        cardToPreview: $scope.cardToPreview
      };
      $scope.isPreview = $scope.cardToPreview;
      Utils.fetchMetricData(fetchCfg, $scope);
    }
  }]).controller(id + ".Detail", ["$scope", "CardRegistry", id + '.Utils', 'AggregationUtils', '$routeParams', 'CardUtils', 'ReportValidationService', '$uibModal', 'lister.Utils', 'Logger', function ($scope, CardRegistry, Utils, AggUtils, $routeParams, CardUtils, ReportValidationService, $uibModal, ListerUtils, Logger) {
    $scope.cardId = $routeParams.cardId;
    $scope.card = CardRegistry.get($scope.cardId);
    $scope.config = $scope.card.configuration;
    $scope.pagenote = {
      "clearCacheAction": "cards/" + $scope.cardId + "/cache"
    };

    // For clickable aggregation values
    $scope.openModal = function openModal(r, m, mi) {
      $scope.selectedRow = r;
      $scope.selectedMeasure = m;
      $scope.selectedMeasureIndex = mi;
      ListerUtils.getModalData(r, m, mi, $scope.config).then(function (modalData) {
        $scope.modalCardToPreview = modalData.cardToPreview;
        $scope.modalData = modalData.data;
        $scope.isDetailsData = modalData.isDetailsData;
        $scope.modalSortBy = modalData.sortBy;
        $scope.modalSortControls = modalData.sortControls;
        $uibModal.open({
          templateUrl: 'modules/app/lister/lister-modal.html',
          controller: 'lister.Modal',
          backdrop: 'static',
          scope: $scope,
          size: 'lg'
        });
      }, function () {
        Logger.error('getModalData failed, unable to display collection of measure values.');
      });
    };
    var validation = ReportValidationService.validate($scope.cardId);
    if (validation.hasErrors) {
      $scope.hasData = false;
      $scope.noDataMsg = validation.message;
      return;
    }

    // If there aren't any measures, this is a simple text display
    $scope.measures = $scope.config.measures;
    if (!$scope.measures || $scope.measures.length < 1) {
      $scope.hasData = true;
      Utils.interpolateMetricText([], $scope);
    } else {
      var fetchCfg = {
        cardId: $scope.cardId,
        cardToPreview: $scope.cardId === 'preview' ? $scope.card : null
      };
      $scope.isPreview = $scope.cardId === 'preview';
      Utils.fetchMetricData(fetchCfg, $scope).finally(function () {
        CardUtils.setNavElements($scope, $scope.cardId, $scope.cardId);
      });
    }
  }]);
})();
